import type { ChangePaginationModel } from '../../data/change-pagination-model';

export class ChangePaginationAction {
  static readonly type = '[Table] ChangePagination';

  constructor(readonly pagination: ChangePaginationModel) {}
}
